import React, { useEffect, useState } from 'react'
import './Css/products.css'
import { Link } from 'react-router-dom'

const res = [
  {
    id:1,
    images:"/images/electric-pallet-truck.webp",
    heading:"Electric Pallet Truck",
    link:"/products/electric-pallet-truck"
  },
  {
    id:2,
    images:"/images/Hydraulic-Hand-Pallet.jpg",
    heading:"Hand Pallet Truck",
    link:"/products/hand-pallet-truck"
  },
  {
    id:3,
    images:"/images/scissor.png",
    heading:"Scissor Trolley",
    link:"/products/scissor-trolley"
  },
  {
    id:4,
    images:"/images/high-lift-pallet.png",
    heading:"High Lift Pallet Truck",
    link:"/products/high-lift-pallet"
  },
  {
    id:5,
    images:"/images/power-stacker.png",
    heading:"Power Stacker",
    link:"/products/power-stacker"
  },
  {
    id:6,
    images:"/images/manual-stacker.png",
    heading:"Manual Stacker",
    link:"/products/manual-stacker"
  },
  {
    id:7,
    images:"/images/goods-lift.png",
    heading:"Goods Lift",
    link:"/products/goods-lift"
  },
  {
    id:8,
    images:"/images/dock-leveler.jpg",
    heading:"Dock Leveler",
    link:"/products/dock-leveler"
  },
  {
    id:9,
    images:"/images/paper-roller-handling.jpg",
    heading:"Paper Roller Handling",
    link:"/products/paper-roller-handling"
  },
]
const Products = () => {
  const [hover, hoverState] = useState(false)
  const [idstate, idSetter] = useState(1)
  useEffect(()=>{
  if(hover){
    // console.log(document.getElementById(idstate).children[1])
    document.getElementById(idstate).children[1].style.color = "#ED9456";
  }
  else{
    document.getElementById(idstate).children[1].style.color = "black";
  }
  },[hover])
  return (
    <>
      <div id='phead'>Products:</div>
      {/* <hr /> */}
      <div className="masterblock">
        {res.map((res)=>{
          return (
            <Link to={res.link}>
              <div
                className="block"
                id={res.id}
                onMouseEnter={()=> {hoverState(true); idSetter(res.id)}}
                onMouseLeave={()=> hoverState(false)}
              >
                <img src={res.images} alt="" width={300} />
                <div className="prod-heading">{res.heading}</div>
              </div>
            </Link>
          );
        })}
      </div>
    </>
  );
}

export default Products